import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@assets/img/icons/check-2.svg?react';
import cn from 'classnames';

import { ModalContext } from '@/components/Modals/Modal/config';
import { H1, H2, StringMain } from '@/components/Typography/Typography';
import { changePaymentStatus } from '@/redux/reducers/paymentsReducer';
import { useAppDispatch } from '@/redux/store';

import css from './style.module.scss';

interface props {
  className?: string;
  children?: React.ReactNode;
  handleClose?: () => void;
}

const SuccessfullStatus: React.FC<props> = ({
  children,
  className,
  handleClose,
}) => {
  const { closeModal, secondModal } = useContext(ModalContext);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <>
      <div className={css.title}>
        <H1>{t('Congrats!')}</H1>
        <H2>{t('Purchase completed!')}</H2>
      </div>
      <div className={cn('relative', className)}>
        {children}
        <div className={cn(css.complete)}>
          <div className={css.check}>
            <CheckIcon className="w-[25px] h-[20px]" />
          </div>
        </div>
      </div>
      <StringMain
        onClick={() => {
          closeModal();
          secondModal.closeModal();

          if (handleClose) {
            handleClose();
          }
          dispatch(changePaymentStatus(undefined));
        }}
        weight="extrabold"
        className="text-[20px] mt-[50px]"
      >
        {t('Tap to continue')}
      </StringMain>
    </>
  );
};

export default SuccessfullStatus;
